import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField, Tooltip, Chip } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder="Chọn ngày"
        style={{
            height: "40px",
            padding: "0 10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "14px",
            color: "#333",
            backgroundColor: "#fff",
            width: "120px",
            textAlign: "center",
            cursor: "pointer"
        }}
        readOnly
    />
));

function Request() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [setting, setSetting] = useState(null);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // Quản lý Phân trang và Tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [status, setStatus] = useState("All");
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const [maGiaoDich, setMaGiaoDich] = useState("");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    // Hàm lấy dữ liệu
    const fetchWithdrawals = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/rut?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchWithdrawals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if (res.data && res.data.data && res.data.data.length > 0) {
                    setSetting(res.data.data[0]);
                }
            })
            .catch((err) => console.log("Lỗi load setting:", err));
    }, []);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                {/* Sub-navigation tabs matching AX68WIN */}
                                <div className="ax-sub-tabs" style={{ margin: 0 }}>
                                    <Link to="/admin/add" style={{ textDecoration: "none" }}>
                                        <div className="ax-sub-tab">Danh sách nạp điểm</div>
                                    </Link>
                                    <div className="ax-sub-tab active">Danh sách rút điểm</div>
                                    <div className="ax-sub-tab">Lịch sử duyệt</div>
                                </div>

                                <button className="ax-guide-button" onClick={() => setIsGuideOpen(true)}>
                                    Hướng dẫn <span>❓</span>
                                </button>
                            </Box>

                            <div className="form_set" style={{ marginTop: 0 }}>
                                <Box>
                                    {/* AX68WIN Filter Block */}
                                    <div className="ax-filter-block">
                                        <div className="ax-filter-grid">
                                            <div className="ax-filter-item" style={{ minWidth: "320px" }}>
                                                <label>📅 Khoảng thời gian</label>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                    <div className="ax-date-range">
                                                        <DatePicker
                                                            maxDate={new Date()}
                                                            selected={startDate}
                                                            onChange={(date) => {
                                                                setStartDate(date);
                                                                setPage(1);
                                                            }}
                                                            customInput={<CustomDateInput />}
                                                        />
                                                        <span style={{ color: "#888" }}>→</span>
                                                        <DatePicker
                                                            maxDate={new Date()}
                                                            selected={endDate}
                                                            onChange={(date) => {
                                                                setEndDate(date);
                                                                setPage(1);
                                                            }}
                                                            customInput={<CustomDateInput />}
                                                        />
                                                    </div>
                                                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(now); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #1890ff", background: "#e6f7ff", color: "#1890ff", fontWeight: 600, cursor: "pointer" }}>Hôm nay</button>
                                                        <button type="button" onClick={() => { const now = new Date(); const s = new Date(); s.setDate(now.getDate() - 6); setStartDate(s); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #722ed1", background: "#f9f0ff", color: "#722ed1", fontWeight: 600, cursor: "pointer" }}>7 ngày qua</button>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(new Date(now.getFullYear(), now.getMonth(), 1)); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #52c41a", background: "#f6ffed", color: "#52c41a", fontWeight: 600, cursor: "pointer" }}>Tháng này</button>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(new Date(now.getFullYear(), now.getMonth() - 1, 1)); setEndDate(new Date(now.getFullYear(), now.getMonth(), 0)); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #fa8c16", background: "#fff7e6", color: "#fa8c16", fontWeight: 600, cursor: "pointer" }}>Tháng trước</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ax-filter-item">
                                                <label>◉ Trạng thái</label>
                                                <select
                                                    value={status}
                                                    onChange={(e) => {
                                                        setStatus(e.target.value);
                                                        setPage(1);
                                                    }}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                >
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Pending">Chưa xử lý</option>
                                                    <option value="Success">Thành công</option>
                                                    <option value="Deny">Thất bại</option>
                                                </select>
                                            </div>

                                            <div className="ax-filter-item">
                                                <label>👤 Tên người chơi</label>
                                                <input
                                                    type="text"
                                                    placeholder="Tên người chơi"
                                                    onChange={handleSearchChange}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                />
                                            </div>

                                            <div className="ax-filter-item">
                                                <label># Mã giao dịch</label>
                                                <input
                                                    type="text"
                                                    placeholder="Mã giao dịch"
                                                    value={maGiaoDich}
                                                    onChange={(e) => setMaGiaoDich(e.target.value)}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                />
                                            </div>

                                            <div className="ax-filter-item" style={{ flexDirection: "row", gap: "8px" }}>
                                                <button className="ax-btn-search-red" onClick={() => { setPage(1); fetchWithdrawals(); }}>
                                                    🔍 Tìm kiếm
                                                </button>
                                                <button className="ax-btn excel" style={{ height: "40px", borderRadius: "8px" }} onClick={() => swal(t("success"), "Đã xuất file excel", "success")}>
                                                    📊 Xuất excel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* AX68WIN Summary Boxes */}
                                    <div className="ax-summary-row">
                                        <div className="ax-summary-box pending">
                                            <div className="ax-icon">📦</div>
                                            <div className="ax-info">
                                                <div className="ax-label">Chưa xử lý</div>
                                                <div className="ax-value">{Math.floor(totalPending || 0).toLocaleString("vi-VN")}</div>
                                            </div>
                                        </div>
                                        <div className="ax-summary-box success">
                                            <div className="ax-icon">✅</div>
                                            <div className="ax-info">
                                                <div className="ax-label">Thành công</div>
                                                <div className="ax-value">{Math.floor(totalSuccess || 0).toLocaleString("vi-VN")}</div>
                                            </div>
                                        </div>
                                        <div className="ax-summary-box failed">
                                            <div className="ax-icon">❌</div>
                                            <div className="ax-info">
                                                <div className="ax-label">Thất bại</div>
                                                <div className="ax-value">0</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#FF0000" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>TÊN ĐĂNG NHẬP</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>ID</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>PHƯƠNG THỨC THANH TOÁN</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>SỐ TIỀN</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>SỐ DƯ</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>TRẠNG THÁI</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>CẢNH BÁO RỦI RO</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>HÀNH ĐỘNG</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>THỜI GIAN</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {/* Hiển thị thẳng dữ liệu */}
                                                {data.map((item) => (
                                                    <TableRow key={item._id}>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.username}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.iduser}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                            <div>{item?.detail}</div>
                                                            <div style={{ fontSize: "11px", color: "#666", fontWeight: "normal", marginTop: "4px" }}>
                                                                {item?.orderNo && <div>Mã: {item.orderNo}</div>}
                                                                {item?.channel && <div>Kênh: {item.channel}</div>}
                                                                {item?.ipAddress && <div>IP: {item.ipAddress}</div>}
                                                                {item?.domain && <div>Domain: {item.domain}</div>}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{Number(item?.money).toLocaleString("vi-VN")} </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                            <span>{item?.user?.money?.toLocaleString("vi-VN")}</span>
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {item?.status_payment === "Pending" && <span className="badge warning">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Success" && <span className="badge success">{item?.status_payment}</span>}
                                                            {item?.status_payment === "Deny" && <span className="badge error">{item?.status_payment}</span>}
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {item.riskScore !== undefined ? (
                                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "flex-start" }}>
                                                                    {item.riskScore >= 80 ? (
                                                                        <Chip
                                                                            label={`Rủi ro cao (${item.riskScore})`}
                                                                            color="error"
                                                                            size="small"
                                                                            sx={{ fontWeight: "bold" }}
                                                                        />
                                                                    ) : item.riskScore >= 40 ? (
                                                                        <Chip
                                                                            label={`Rủi ro TB (${item.riskScore})`}
                                                                            color="warning"
                                                                            size="small"
                                                                            sx={{ fontWeight: "bold" }}
                                                                        />
                                                                    ) : item.riskScore > 0 ? (
                                                                        <Chip
                                                                            label={`Rủi ro thấp (${item.riskScore})`}
                                                                            size="small"
                                                                            sx={{ fontWeight: "bold", backgroundColor: "#fbc02d", color: "#000" }}
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            label="An toàn (0)"
                                                                            color="success"
                                                                            size="small"
                                                                            sx={{ fontWeight: "bold" }}
                                                                        />
                                                                    )}

                                                                    {item.warnings && item.warnings.length > 0 && (
                                                                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "2px", mt: 0.5 }}>
                                                                            {item.warnings.map((warn, wIdx) => (
                                                                                <Tooltip key={wIdx} title={warn.message} arrow>
                                                                                    <Chip
                                                                                        label={warn.code}
                                                                                        size="small"
                                                                                        sx={{
                                                                                            fontSize: "10px",
                                                                                            height: "18px",
                                                                                            backgroundColor: warn.code === 'WAGER_NOT_MET' ? '#ffebee' : '#fff3e0',
                                                                                            color: warn.code === 'WAGER_NOT_MET' ? '#c62828' : '#e65100',
                                                                                            border: `1px solid ${warn.code === 'WAGER_NOT_MET' ? '#ffcdd2' : '#ffe0b2'}`,
                                                                                            cursor: "pointer",
                                                                                            "& .MuiChip-label": { paddingLeft: "4px", paddingRight: "4px" }
                                                                                        }}
                                                                                    />
                                                                                </Tooltip>
                                                                            ))}
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            ) : (
                                                                <span style={{ color: "#999" }}>N/A</span>
                                                            )}
                                                        </TableCell>
                                                        
                                                        <TableCell sx={{ padding: "10px" }}>
                                                            {profile?.isAdmin || profile?.permission?.money == 1 ? (
                                                                <>
                                                                    <textarea
                                                                        type="text"
                                                                        name="note"
                                                                        defaultValue={item?.note}
                                                                        disabled={item?.status_payment !== "Pending"}
                                                                        onChange={(e) => setNote(e.target.value)}
                                                                    />
                                                                    <div style={{ display: "flex", gap: "5px", marginTop: "5px", flexWrap: "wrap" }}>
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="small"
                                                                            style={{ textTransform: "none" }}
                                                                            onClick={() => {
                                                                                setLoading(true);
                                                                                const formData = {
                                                                                    id: item?._id,
                                                                                    status: "Accept",
                                                                                    note: note,
                                                                                    is_payspec: false
                                                                                };
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                    .then(() => {
                                                                                        swal(t("success"), "Duyệt đơn thủ công thành công!", "success");
                                                                                        fetchWithdrawals();
                                                                                    })
                                                                                    .catch(() => {
                                                                                        swal(t("error"), "", "error");
                                                                                        fetchWithdrawals();
                                                                                    });
                                                                            }}
                                                                            disabled={item?.status_payment !== "Pending"}>
                                                                            {t("confirm")}
                                                                        </Button>
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="error"
                                                                            size="small"
                                                                            style={{ textTransform: "none" }}
                                                                            onClick={() => {
                                                                                setLoading(true);
                                                                                const formData = {
                                                                                    id: item?._id,
                                                                                    status: "Deny",
                                                                                    note: note
                                                                                };
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                    .then(() => {
                                                                                        swal(t("success"), "", "success");
                                                                                        fetchWithdrawals(); // Fetch lại thay vì reload
                                                                                    })
                                                                                    .catch(() => {
                                                                                        swal(t("error"), "", "error");
                                                                                        fetchWithdrawals();
                                                                                    });
                                                                            }}
                                                                            disabled={item?.status_payment !== "Pending"}>
                                                                            {t("deny")}
                                                                        </Button>
                                                                        {item?.type_payment === "RÚT" && setting?.payspec_status === true && (
                                                                            <Button
                                                                                variant="contained"
                                                                                color="success"
                                                                                size="small"
                                                                                style={{ textTransform: "none" }}
                                                                                onClick={() => {
                                                                                    swal({
                                                                                        title: "Duyệt qua PAYSPEC",
                                                                                        text: "Nhập Mật khẩu cấp 2 của cổng PAYSPEC để thực hiện chuyển khoản:",
                                                                                        content: {
                                                                                            element: "input",
                                                                                            attributes: {
                                                                                                placeholder: "Mật khẩu cấp 2 PAYSPEC",
                                                                                                type: "password",
                                                                                            },
                                                                                        },
                                                                                        buttons: {
                                                                                            cancel: "Hủy",
                                                                                            confirm: {
                                                                                                text: "Duyệt chuyển tiền",
                                                                                                closeOnConfirm: true,
                                                                                            }
                                                                                        },
                                                                                    }).then((pwd) => {
                                                                                        if (pwd === null) return;
                                                                                        if (!pwd.trim()) {
                                                                                            swal("Lỗi", "Mật khẩu cấp 2 không được để trống!", "error");
                                                                                            return;
                                                                                        }
                                                                                        setLoading(true);
                                                                                        const formData = {
                                                                                            id: item?._id,
                                                                                            status: "Accept",
                                                                                            note: note,
                                                                                            is_payspec: true,
                                                                                            payspec_password_two: pwd.trim()
                                                                                        };
                                                                                        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                            .then((res) => {
                                                                                                if (res.data && res.data.success === false) {
                                                                                                    swal("Lỗi", res.data.message || "Duyệt đơn thất bại", "error");
                                                                                                } else {
                                                                                                    swal(t("success"), "Đã gửi lệnh rút tiền tự động thành công!", "success");
                                                                                                }
                                                                                                fetchWithdrawals();
                                                                                            })
                                                                                            .catch((err) => {
                                                                                                swal("Lỗi", err.response?.data?.message || t("error"), "error");
                                                                                                fetchWithdrawals();
                                                                                            });
                                                                                    });
                                                                                }}
                                                                                disabled={item?.status_payment !== "Pending"}>
                                                                                Duyệt PAYSPEC
                                                                            </Button>
                                                                        )}
                                                                        {item?.type_payment === "RÚT" && setting?.v8pay_status === true && (
                                                                            <Button
                                                                                variant="contained"
                                                                                color="secondary"
                                                                                size="small"
                                                                                style={{ textTransform: "none", backgroundColor: "#7b1fa2", color: "#fff" }}
                                                                                onClick={() => {
                                                                                    swal({
                                                                                        title: "Duyệt qua V8PAY",
                                                                                        text: "Bạn có chắc chắn muốn duyệt tự động đơn hàng này qua cổng V8PAY?",
                                                                                        icon: "warning",
                                                                                        buttons: ["Hủy", "Duyệt chuyển tiền"],
                                                                                        dangerMode: true,
                                                                                    }).then((willApprove) => {
                                                                                        if (!willApprove) return;
                                                                                        setLoading(true);
                                                                                        const formData = {
                                                                                            id: item?._id,
                                                                                            status: "Accept",
                                                                                            note: note,
                                                                                            is_v8pay: true
                                                                                        };
                                                                                        axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                            .then((res) => {
                                                                                                if (res.data && res.data.success === false) {
                                                                                                    swal("Lỗi", res.data.message || "Duyệt đơn thất bại", "error");
                                                                                                } else {
                                                                                                    swal(t("success"), "Đã gửi lệnh rút tiền tự động V8PAY thành công!", "success");
                                                                                                }
                                                                                                fetchWithdrawals();
                                                                                            })
                                                                                            .catch((err) => {
                                                                                                swal("Lỗi", err.response?.data?.message || t("error"), "error");
                                                                                                fetchWithdrawals();
                                                                                            });
                                                                                    });
                                                                                }}
                                                                                disabled={item?.status_payment !== "Pending"}>
                                                                                Duyệt V8PAY
                                                                            </Button>
                                                                        )}
                                                                        {item?.type_payment === "RÚT" && setting?.saobang_status === true && (
                                                                             <Button
                                                                                 variant="contained"
                                                                                 color="success"
                                                                                 size="small"
                                                                                 style={{ textTransform: "none", backgroundColor: "#2e7d32", color: "#fff" }}
                                                                                 onClick={() => {
                                                                                     swal({
                                                                                         title: "Duyệt qua SAOBANG",
                                                                                         text: "Bạn có chắc chắn muốn duyệt tự động đơn hàng này qua cổng SAOBANG?",
                                                                                         icon: "warning",
                                                                                         buttons: ["Hủy", "Duyệt chuyển tiền"],
                                                                                         dangerMode: true,
                                                                                     }).then((willApprove) => {
                                                                                         if (!willApprove) return;
                                                                                         setLoading(true);
                                                                                         const formData = {
                                                                                             id: item?._id,
                                                                                             status: "Accept",
                                                                                             note: note,
                                                                                             is_saobang: true
                                                                                         };
                                                                                         axios.post(`${process.env.REACT_APP_API_URL}/payment/update`, formData)
                                                                                             .then((res) => {
                                                                                                 if (res.data && res.data.success === false) {
                                                                                                     swal("Lỗi", res.data.message || "Duyệt đơn thất bại", "error");
                                                                                                 } else {
                                                                                                     swal(t("success"), "Đã gửi lệnh rút tiền tự động SAOBANG thành công!", "success");
                                                                                                 }
                                                                                                 fetchWithdrawals();
                                                                                             })
                                                                                             .catch((err) => {
                                                                                                 swal("Lỗi", err.response?.data?.message || t("error"), "error");
                                                                                                 fetchWithdrawals();
                                                                                             });
                                                                                     });
                                                                                 }}
                                                                                 disabled={item?.status_payment !== "Pending"}>
                                                                                 Duyệt SAOBANG
                                                                             </Button>
                                                                         )}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div>{t("not_permission")}</div>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDate(new Date(item?.createdAt))}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={9} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                    </div>
                                </Box>
                            </div>
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                    {isGuideOpen && (
                        <div className="ax-modal-overlay" onClick={() => setIsGuideOpen(false)}>
                            <div className="ax-modal-card" onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header">
                                    <h3>Hướng dẫn chi tiết</h3>
                                    <span className="close-icon" onClick={() => setIsGuideOpen(false)}>✕</span>
                                </div>
                                <div className="ax-modal-body">
                                    <h4>Khoảng thời gian</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với thời gian đã chọn.</li>
                                    </ul>

                                    <h4>Trạng thái</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với trạng thái đã chọn.</li>
                                        <li>Có 4 sự lựa chọn lần lượt là: Toàn bộ, Chưa xử lý, Thành công, Thất bại. Mặc định là 'Toàn bộ'.</li>
                                    </ul>

                                    <h4>Tên người chơi</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Mã giao dịch</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Mã giao dịch' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Xuất excel</h4>
                                    <ul>
                                        <li>Được sử dụng để xuất một file excel với tất cả dữ liệu là các thông tin được hiển thị trên bảng kết quả trên màn hình.</li>
                                        <li>Lưu ý: Không thể xuất file của dữ liệu rỗng.</li>
                                    </ul>
                                </div>
                                <div className="ax-modal-footer">
                                    <button className="ax-btn-modal-close" onClick={() => setIsGuideOpen(false)}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default Request;